var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IssueResultActivationCode } from "./IssueResultActivationCode";
import i18next from "i18next";
var IssueResult = /** @class */ (function (_super) {
    __extends(IssueResult, _super);
    function IssueResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.printDiv = null;
        return _this;
    }
    IssueResult.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return props.activationCode ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-3" }, i18next.t("cc.issue.result.printInformationAndLeaveUser")),
            React.createElement("div", { ref: function (ref) { return (_this.printDiv = ref); } },
                React.createElement(IssueResultActivationCode, __assign({}, props))),
            React.createElement("div", { className: "text-right" },
                React.createElement("button", { className: "btn btn-link", onClick: function () {
                        PrintElem(_this.printDiv);
                    } }, i18next.t("cc.issue.result.print"))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-3" }, i18next.t("cc.issue.result.userIssued"))));
    };
    return IssueResult;
}(React.PureComponent));
export { IssueResult };
function PrintElem(elem) {
    var mywindow = window.open("", i18next.t("cc.issue.result.print"), "");
    mywindow.document.write("<html><head><title>SkolID</title>");
    mywindow.document.write("<style>body { font-family: 'Arial' }</style>");
    mywindow.document.write("</head><body>");
    mywindow.document.write(elem.innerHTML);
    mywindow.document.write("</body></html>");
    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    mywindow.print();
    mywindow.close();
    return true;
}
//# sourceMappingURL=IssueResult.js.map